// extracted by mini-css-extract-plugin
export default {"card":"Card_card__KSRS3","flush":"Card_flush__Ozlx4","head":"Card_head__CiDPT","title":"Card_title__S2F2I","actions":"Card_actions__RnnJj"};